import firebase from 'firebase';

export default {
  namespaced: true,
  state: {
    video: [],
    pagination: null
  },
  getters: {
    getVideo(state) {
      return state.video
    }
  },
  mutations: {
    setVideos(state, payload) {
      state.video = payload
    },
    addVideo(state, payload) {
      state.video.push(payload)
    },
    delVideo(state, payload) {
      state.video = state.video.filter(item => item.id !== payload);
    },
    updateVideo(state, payload) {
      const index = state.video.findIndex(v => v.id === payload.id)
      state.video.splice(index, 1, payload)
    },
    setPagination(state, payload) {
      state.pagination = payload
    }
  },
  actions: {
    async addVideo({dispatch, commit}, {title, discription, link}) {
      try {
        const response  = await firebase.database().ref('database/video').push({
          title: title,
          discription: discription,
          link: link
        })
        commit('addVideo', {id: response.key, title, discription, link})
      } catch (e) {
        throw e
      }
    },
    async getVideosLength({commit}) {
      await firebase.database().ref(`/database/video`).on("value", function(snapshot) {
        let allVideosArr = snapshot.numChildren() / 4
        allVideosArr = allVideosArr % 2 === 0 ?  Math.round(allVideosArr) : allVideosArr + 1
        commit('setPagination', allVideosArr)
      })
    },
    async fetchVideos() {
      const videos = (await firebase.database().ref(`/database/video`).once('value')).val() || {}
      return Object.keys(videos).map(key => ({...videos[key], id: key}))
    },
    async fetchFourVideos() {
      const videos = (await firebase.database().ref(`/database/video`).limitToFirst(4).once('value')).val() || {}
      return Object.keys(videos).map(key => ({...videos[key], id: key}))
    },
    async deleteVideo({commit}, id) {
      try {
        await firebase.database().ref(`/database/video/${id}`).remove()
        commit('delVideo', id)
      } catch (e) {
        throw e
      }
    },
    async updateVideo({commit}, {id, title, discription, link}) {
      try {
        await firebase.database().ref(`/database/video`).child(id).update({title, discription, link})
        const payload = {id, title, discription, link}
        commit('updateVideo', payload)
      } catch (e) {
        throw e
      }
    }
  }
}